import { render } from "./InputText.vue?vue&type=template&id=3c8f16a0&scoped=true"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"

import "./InputText.vue?vue&type=style&index=0&id=3c8f16a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8f16a0"]])

export default __exports__